import type { ReactNode } from 'react';
import styles from './MonthGroup.module.css';

interface MonthGroupProps {
  label: string;
  children: ReactNode;
}

export default function MonthGroup({ label, children }: MonthGroupProps) {
  return (
    <section className={styles.group}>
      <div className={styles.header}>
        <h3 className={styles.label}>{label}</h3>
        <div className={styles.rule} />
      </div>
      <div className={styles.studies}>{children}</div>
    </section>
  );
}
